import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/** @jsx jsx */
import { Component } from 'react';
import { css, jsx } from '@emotion/react';
import { N300 } from '@atlaskit/theme/colors';
import ColumnCell from './internal/common-cell';
import withColumnWidth from './internal/with-column-width';
var headerStyles = css({
  color: "var(--ds-text-subtle, ".concat(N300, ")"),
  fontSize: "var(--ds-font-size-075, 12px)",
  fontWeight: "var(--ds-font-weight-bold, bold)",
  letterSpacing: -0.1,
  lineHeight: "var(--ds-font-lineHeight-200, 20px)"
});
var Header = /*#__PURE__*/function (_Component) {
  _inherits(Header, _Component);
  var _super = _createSuper(Header);
  function Header() {
    _classCallCheck(this, Header);
    return _super.apply(this, arguments);
  }
  _createClass(Header, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return (
        // TODO: Determine whether proper `th` elements can be used instead of
        // roles (DSP-11588)
        jsx(ColumnCell, _extends({
          css: headerStyles,
          role: "columnheader",
          style: {
            width: props.width
          }
        }, props), props.children)
      );
    }
  }]);
  return Header;
}(Component);
export default withColumnWidth(Header);